var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("SimpleTextPopup", {
        attrs: {
          title: _vm.$t("PleaseEnterYourEmailAddress"),
          showTextbox: true,
          rightButtonText: _vm.$t("sendEmail"),
          rightMethod: _vm.sendResetPasswordEmail,
          small: ""
        },
        on: {
          popupClose: function($event) {
            return _vm.$emit("input", false)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c(
                  "div",
                  [
                    _c("v-text-field", {
                      ref: "thepopup",
                      attrs: {
                        "prepend-icon": "mail",
                        name: "input-3",
                        label: "email",
                        rules: [
                          _vm.fieldIsEmail(),
                          _vm.fieldIsRequired("email")
                        ]
                      },
                      model: {
                        value: _vm.email,
                        callback: function($$v) {
                          _vm.email = $$v
                        },
                        expression: "email"
                      }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "popupAction",
            fn: function() {
              return [
                _c(
                  "v-layout",
                  { attrs: { row: "", "justify-space-between": "" } },
                  [
                    _c(
                      "v-flex",
                      { staticClass: "text-xs-left" },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "primary", flat: "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.$emit("input", false)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("close")))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { staticClass: "text-xs-right" },
                      [
                        _c(
                          "v-layout",
                          [
                            _c(
                              "v-flex",
                              { attrs: { xs8: "" } },
                              [
                                _vm.isNonVPN
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(tooltip) {
                                                return [
                                                  _c(
                                                    "div",
                                                    _vm._g({}, tooltip.on),
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            icon: "",
                                                            color: "primary",
                                                            flat: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              _vm.isShowParseUrlPopup = true
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v(
                                                              "fast_forward"
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          2133331678
                                        )
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("parseUrl")) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { flat: "", color: "primary" },
                                    on: { click: _vm.sendResetPasswordEmail }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("send")))]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.value,
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      }),
      _vm._v(" "),
      _c("ParseSignupUrlPopup", {
        attrs: { email: _vm.email },
        model: {
          value: _vm.isShowParseUrlPopup,
          callback: function($$v) {
            _vm.isShowParseUrlPopup = $$v
          },
          expression: "isShowParseUrlPopup"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b5bb1fcc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5bb1fcc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResetPasswordEmailPopup.vue
// module id = null
// module chunks = 